import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FeaturedPartners = () => {
  const partners = [
  {
    id: 1,
    name: 'Department of Tourism',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15558ffdf-1766827831507.png",
    logoAlt: 'Philippine Department of Tourism official logo with blue and red colors representing government tourism authority',
    type: 'Government',
    description: 'Official tourism authority of the Philippines'
  },
  {
    id: 2,
    name: 'Tourism Promotions Board',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_17c93198c-1770047453350.png",
    logoAlt: 'Tourism Promotions Board Philippines logo featuring vibrant colors and tourism symbols',
    type: 'Government',
    description: 'Promoting Philippine tourism worldwide'
  },
  {
    id: 3,
    name: 'Philippine Airlines',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12baee623-1768954141488.png",
    logoAlt: 'Philippine Airlines logo with iconic blue and red airline branding and aircraft symbol',
    type: 'Transport',
    description: 'National flag carrier of the Philippines'
  },
  {
    id: 4,
    name: 'Cebu Pacific',
    logo: "https://images.unsplash.com/photo-1564689439743-baefac4b52d8",
    logoAlt: 'Cebu Pacific airline logo with bright yellow and blue colors representing budget airline service',
    type: 'Transport',
    description: 'Leading low-cost carrier in Asia'
  },
  {
    id: 5,
    name: 'Shangri-La Hotels',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1c2f7595c-1767811067543.png",
    logoAlt: 'Shangri-La Hotels luxury brand logo with elegant gold lettering on dark background',
    type: 'Hospitality',
    description: 'Luxury hospitality across the Philippines'
  },
  {
    id: 6,
    name: 'Discovery Hotels',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7a241ea-1770047454697.png",
    logoAlt: 'Discovery Hotels and Resorts logo featuring modern design with tropical resort imagery',
    type: 'Hospitality',
    description: 'Premium resorts and leisure destinations'
  }];


  return (
    <section className="py-2 md:py-3 bg-slate-700">
      <div className="max-w-[1200px] mx-auto px-2 md:px-3 bg-slate-700">
        {/* Section Header */}
        <div className="text-center mb-2 md:mb-3 bg-slate-700">
          <div className="inline-flex items-center gap-0.5 px-1 py-0.5 bg-secondary/10 rounded-full mb-1">
            <Icon name="Handshake" size={9} color="var(--color-secondary)" className="bg-orange-50" />
            <span className="font-medium text-orange-400 md:text-xs text-xs">Trusted Partnerships</span>
          </div>
          <h2 className="text-xs md:text-base font-bold mb-1 text-neutral-50">
            Featured Partners
          </h2>
          <p className="text-[8px] md:text-[10px] max-w-2xl mx-auto text-neutral-50">
            We collaborate with government agencies, leading airlines, and premium hospitality brands to ensure authentic and quality experiences
          </p>
        </div>

        {/* Partners Grid - 4 columns */}
        <div className="grid grid-cols-4 gap-1.5 md:gap-2.5 mb-2 md:mb-3">
          {partners?.map((partner) =>
          <div
            key={partner?.id}
            className="group p-1 rounded-lg border border-border hover:border-primary/30 hover:shadow-lg transition-all duration-300 bg-slate-600 border-none max-w-[80px] mx-auto">

              <div className="aspect-square mb-0.5 overflow-hidden rounded-md w-[50px] h-[50px] mx-auto">
                <Image
                src={partner?.logo}
                alt={partner?.logoAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />

              </div>
              <div className="text-center">
                <p className="text-[6px] md:text-[8px] font-semibold mb-0.5 line-clamp-2 text-orange-300 break-words">
                  {partner?.name}
                </p>
                <p className="text-[5px] md:text-[7px] text-white">{partner?.type}</p>
              </div>
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="mt-2 md:mt-3 text-center">
          <p className="mb-1 font-medium text-white text-[10px] md:text-xs text-center">
            Want to become a partner? Learn more about our partnership program
          </p>
          <button className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-primary text-primary-foreground rounded-lg text-[8px] md:text-[10px] font-medium hover:bg-primary/90 transition-all duration-300">
            <Icon name="Mail" size={9} color="#FFFFFF" />
            <span>Contact Partnership Team</span>
          </button>
        </div>
      </div>
    </section>);

};

export default FeaturedPartners;